var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("h" + (_vm.variant === 'secondary' ? '2' : '1')),{tag:"component",staticClass:"dc-logo",attrs:{"data-cy":"dc-logo"}},[_vm._v("Daily"),_c('span',[_vm._v("Chat")])])}
var staticRenderFns = []

export { render, staticRenderFns }